module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)",
      "origin": "top right",
      "offset-y": "offset-y",
      "transition": "slide-y-transition"
    },
    on: {
      "click:outside": _vm.openPopup
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "color": "success",
            "offset-x": _vm.countDescargas ? 26 : -15,
            "offset-y": _vm.countDescargas ? 22 : -15,
            "content": _vm.countDescargas,
            "bordered": "bordered",
            "overlap": "overlap"
          }
        }, [_c('v-btn', {
          staticClass: "mx-1",
          attrs: {
            "icon": "icon",
            "depressed": ""
          },
          on: {
            "click": function($event) {
              return _vm.openPopup()
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "28"
          }
        }, [_vm._v("cloud_download")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.openCentroDeDescargas),
      callback: function($$v) {
        _vm.openCentroDeDescargas = $$v
      },
      expression: "openCentroDeDescargas"
    }
  }, [_c('v-card', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)"
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('strong', [_vm._v("Procesos pendientes")])]), (_vm.showProcesos) ? _c('procesos-handler') : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-8"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("Ningún proceso en curso")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("No se encontraron procesos disponibles para mostrar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-454554ee","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_descargas_procesos_app.vue
// module id = 495
// module chunks = 1